import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {GridList, GridTile} from 'material-ui/GridList';

const mapStateToProps = state => ({
  ...state.gallery,
  ...state.mediums
});

const mapDispatchToProps = dispatch => ({
    onImageClick: (currentImage, images) => dispatch({type: 'IMAGE_CLICK', currentImage: currentImage, images: images})
});

const ArtistPreview = props => {

  const artist = props.artist;
  const styles = {
    root: {
      maxWidth: '80vw',
      height: 282,
      margin: 20,
      padding: 20
    },
    listHolder: {
      display: 'flex',
      overflow: 'hidden',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    },
    gridList: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      margin: '10px 0 0'
    },
    mediums: {
      color: '#aaaaaa',
      fontSize: '14px',
      letterSpacing: '1px'
    },
    meta: {
      color: '#aaaaaa',
      fontSize: '14px',
      letterSpacing: '1px'
    },
    spacer: {
      margin: '0 10px',
      color: '#DDD'
    }
  };

  const mapMediums = mediums => {
    let mediumsStr = "";
    mediums.map(medium => mediumsStr += props.mediums[medium] + ", ");
    return mediumsStr.replace(/,\s*$/, "");
  }

  const onImageClick = (index, images) => {
    props.onImageClick(index, images);
  }

  let location = artist.location ? <span><span style={styles.spacer}>|</span> {artist.location}</span> : null;
  let agency = artist.agency ? <span><span style={styles.spacer}>|</span>{artist.agency}</span> : null;
  let instagram = artist.instagram ? <span><span style={styles.spacer}>|</span><a style={{color: '#aaaaaa'}} href={artist.instagram} target="_blank">Instagram</a></span> : null;
  let website = artist.website ? <span><span style={styles.spacer}>|</span><a style={{color: '#aaaaaa'}} href={artist.website} target="_blank">Website</a></span> : null;

  return (
    <div style={styles.root}>
      <Link
        to={`/artist/${artist.id}`}
        style={{color: 'black', textDecoration: 'none', fontSize: '24px'}}
      >
        {artist.name}
      </Link>
      <div>
        <span style={styles.mediums}>{artist.mediums &&

          mapMediums(artist.mediums)
        }</span>
        <span style={styles.meta}>
          {location}
          {agency}
          {instagram}
          {website}
        </span>
      </div>
      <div style={styles.listHolder}>
        <GridList style={styles.gridList} cellHeight={200}>
          {artist.images &&

              artist.images.map((tile, index) => {
                const images = artist.images.map(image => ({src: "http://storage.googleapis.com/art-trove.appspot.com/" + image.original, thumbnail: "http://storage.googleapis.com/art-trove.appspot.com/" + image.thumb}));
                return (
                  <GridTile
                    key={tile.original}
                    style={{cursor:"pointer",flex: "0 0 auto"}}
                    onTouchTap={e => onImageClick(index, images)}
                  >
                      <img src={"http://storage.googleapis.com/art-trove.appspot.com/" + tile.thumb} style={{height: "100%", width: "auto"}}/>
                  </GridTile>
                );
              })
          }
        </GridList>
      </div>
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(ArtistPreview);



// WEBPACK FOOTER //
// ./src/components/ArtistPreview.js